import { createAsyncThunk } from "@reduxjs/toolkit";
import { driver_vital_patients, driver_save_patient_vitals } from "../../../networking/urlEndPoints";

import Axios from "../../../networking/interceptor";

export const fetchVitalPatients = createAsyncThunk(
	'fetchVitalPatients',
	async (requestData, { rejectWithValue }) => {
		const {
			page,
			pharmacy_id,
			setLoading,
			setLoadMore,
		} = requestData || {};

		const stopLoaders = () => {
			if (typeof setLoading === 'function') setLoading(false);
			if (typeof setLoadMore === 'function') setLoadMore(false);
		};

		try {
			const response = await Axios.get(driver_vital_patients, {
				params: { page, pharmacy_id },
			});

			stopLoaders();
			return response.data;

		} catch (error) {
			stopLoaders();

			return rejectWithValue(
				error?.response?.data || {
					message: 'Something went wrong',
				}
			);
		}
	}
);

export const savePatientVitals = createAsyncThunk(
	'savePatientVitals',
	async (requestData, { rejectWithValue }) => {
		const {
			pharmacy_id,
			patient_id,
			vitals,
			setLoading,
			setSuccessToast,
			setErrorToast,
		} = requestData || {};

		const stopLoaders = () => {
			if (typeof setLoading === 'function') setLoading(false);
		};

		try {
			// Vitals are already in structured format from component
			// Just pass them through as-is (they're already transformed)
			const response = await Axios.post(driver_save_patient_vitals, {
				pharmacy_id,
				patient_id,
				vitals: vitals,
			});

			stopLoaders();

			// Show success toast if callback provided
			if (typeof setSuccessToast === 'function') {
				setSuccessToast(true);
				setTimeout(() => {
					setSuccessToast(false);
				}, 2000);
			}

			return response.data;

		} catch (error) {
			stopLoaders();

			// Show error toast if callback provided
			if (typeof setErrorToast === 'function') {
				setErrorToast(true);
				setTimeout(() => {
					setErrorToast(false);
				}, 2000);
			}

			return rejectWithValue(
				error?.response?.data || {
					message: 'Failed to save patient vitals',
				}
			);
		}
	}
);
